import type { UserOrganizationAffiliation } from "@core/features/affiliations";

/**
 * Affiliation display format.
 */
export type Affiliation = {
  id: number | string;
  organizationName: string;
  role?: string;
};

/**
 * Convert UserOrganizationAffiliation to Affiliation format.
 */
export function toAffiliations(
  affiliations: UserOrganizationAffiliation[] | undefined
): Affiliation[] {
  if (!affiliations) return [];
  return affiliations
    .filter((a) => a.organization !== null)
    .map((a) => ({
      id: a.id,
      organizationName: a.organization!.name,
      role: a.affiliation_role?.name,
    }));
}
